<template>
    <div id="page" class="settleIn" :class="[formShow?'pageStyle':'']">
        <img class="main_img" src="../assets/settleln2.png" alt="">
        <div class="btn_img_container" ref="btn_img" @click="openForm()">
            <!-- <img class="btn_img" src="../assets/seetleIn_btn.png" alt=""> -->
        </div>
        <!-- <div class="footer" :class="footer_hide"> -->
        <div class="footer">
            <div class="join_btn" @click="openForm()">我要加入</div>
        </div>
        <div class="form" :class="formFocus" v-show="formShow">
            <div class="form_container" :class="[formContainerTow,formContainerFocus]">
                <div class="form_content">
                    <el-form :inline="true" ref="settleInForm" :model="settleInForm">
                        <div class="form_header">
                            <div class="form_title">填写入驻信息</div>
                            <div class="form_close" @click="formShow = false"><i style="font-size:4.2rem" class="el-icon-close"></i></div>
                        </div>
                        <div class="form_input_block">
                            <el-form-item label="联系人" prop="name">
                                <el-input placeholder="请输入姓名" @blur="inputBlur" @focus="inputFocus" v-model="settleInForm.name"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号" prop="phone">
                                <el-input placeholder="请输入手机号码" @blur="inputBlur" @focus="inputFocus" v-model="settleInForm.phone"></el-input>
                            </el-form-item>
                            <el-form-item class="picker_select" prop="area" label="所在地区" @click.native="pickerShowFun()">
                                <div>
                                    <span v-show="countyName" style="color: #333;">
                                        {{provinceName}} - {{cityName}} - {{countyName}}
                                    </span>
                                    <span v-show="!countyName">请选择地区</span>
                                </div>
                                <div class="right">
                                    <i class="el-icon-arrow-right"></i>
                                </div>

                                <el-input type="text" v-if="0" v-model="settleInForm.area"></el-input>
                            </el-form-item>
                        </div>
                        <div class="checkbox_content">
                            <el-form-item label="经营品牌" prop="brand">
                                <el-checkbox-group @change="barndCheck" v-model="settleInForm.brand">
                                    <el-checkbox :label="item.name" v-for="item in brandList" :key="item.id"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-if="otherBrand_show" prop="otherBrand" class="otherBrand">
                                <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder="请输入其他品牌名称"
                                    v-model="settleInForm.otherBrand">
                                </el-input>
                            </el-form-item>
                        </div>
                        <el-button class="submit" type="primary" @click="onSubmit('settleInForm')">提交</el-button>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="mask" v-if="pickerShowState">
            <div class="picker_contet">
                <div class="picker_header">
                    <div @click="pickerShowState=false">取消</div>
                    <div></div>
                    <div @click="pickerConfirm()">确定</div>
                </div>
                <mt-picker :itemHeight="50" value-key="label" :slots="slots" @change="onValuesChange"></mt-picker>
            </div>
        </div>
        <div class="success_mask mask" v-if="successToast_show">
            <div class="successToast">
                <div class="success_header">
                    <i class="el-icon-close" @click="cancel" style="font-size: 3.57rem;color: #444444;"></i>
                </div>
                <div class="success_icon">
                    <i class="el-icon-success" style="font-size: 7.66rem;color: #23B423;"></i>
                </div>
                <div class="success_prompt">
                    <div>提交成功，请保持电话畅通</div>
                    <div>1-2个工作日会有客服人员联系您</div>
                </div>
                <div class="success_schedule_prompt">
                    如要获悉实时审核进度
                </div>
                <div class="success_triangle">
                    <i style="font-size: 2.3rem;color: #C5C5C5;" class="el-icon-caret-bottom"></i>
                </div>
                <div class="success_vrCode_block">
                    <img src="../assets/vrcode.png" alt="">
                    <div class="success_vrCode_text">
                        <div>长按添加客服微信</div>
                        <div style="color: #FFC43E;">@送水骑士</div>
                    </div>
                </div>
                <div class="confirm" @click="cancel">
                    好的
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import slots from "../util/area/slots"
    import city from "../util/area/city"
    import county from "../util/area/county"
    import { Toast } from 'mint-ui';
    import { getBrand, submitSettled, shares } from '../request/api';
    import wx from 'weixin-js-sdk'; // 引入wxjs
import router from "../router";


    export default {
        components: {
        },
        data () {
            // let checkPhone = (rule, value, callback) => {
            //     let phoneRegExp = /^1[3456789]\d{9}$/
            //     if (!phoneRegExp.test(value)) {
            //         return callback(new Error('请输入正常手机号格式'));
            //     } else{
            //         callback();
            //     }
            // }
            return {
                footer_hide: "",
                formShow: false,
                otherBrand_show: false,
                settleInForm: {
                    name: "",
                    phone: "",
                    otherBrand: "",
                    brand: [],
                    area: ""
                },
                // rules: {
                //     name: [
                //         { required: true, message: '请输入姓名', trigger: 'blur' },
                //     ],
                //     phone: [
                //         { required: true, message: '请输入手机号码', trigger: 'blur' },
                //         { validator: checkPhone, trigger: 'blur' },
                //     ],
                //     brand: [
                //         { required: true, message: '请选择经营品牌', trigger: 'blur' },
                //     ],
                //     area: [
                //         { required: true, message: '请选择地区', trigger: 'input' },
                //     ]
                // },

                slots: slots,
                areaValues: [{value:""},{value:""},{value:""}],
                provinceName: "",
                cityName: "",
                countyName: "",
                pickerShowState: false,
                brandList: [],
                source: "",
                formContainerTow: "",
                innerHeight: "",
                formContainerFocus: "",
                formFocus: "",
                successToast_show: false
            }
        },
        created(){
        },
        mounted() {
            document.title = "送水骑士 | 桶装水门店入驻";

            this.innerHeight = window.innerHeight
            // if(window.location.hash.indexOf("?"!==-1)){
            //     this.source = window.location.hash.split('?')[1].split('=')[1]
            // }
            this.getShareInfo()
            this.getBarndList()
            // window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
        },
        methods:{
            handleScroll(e){

            },
            getShareInfo() {
                // this.save = { url: location.href.split('#')[0] }// 只需要传当前页面地址};
                shares({url:location.href}).then(res => {
                    const config = res.data;
                    wx.config({
                        debug: false,
                        appId: config.appId,  // appID 公众号的唯一标识
                        timestamp: config.timestamp, // 生成签名的时间戳
                        nonceStr: config.nonceStr, //  生成签名的随机串
                        signature: config.signature, // 生成的签名
                        jsApiList: [
                            'updateAppMessageShareData', // 分享到朋友
                            'updateTimelineShareData', // 分享到朋友圈
                        ]
                    });

                    wx.ready(() => {
                        let shareData = {
                            title: '送水骑士 | 桶装水门店入驻',
                            desc: '帮助水店获客，提高30%营收，0费用，0扣点。',
                            link: "http://h5.songshuiqishi.com/#/settleIn?source=2", // 分享后的地址
                            imgUrl: config.logo,
                            success: function (res) {
                            }

                        };
                        //点击要去分享
                        wx.updateAppMessageShareData(shareData);
                        wx.updateTimelineShareData(shareData);
                    })
                });
            },

            pickerShowFun(){
                this.pickerShowState = true
            },

            async getBarndList(){
                let brandList = await getBrand()
                this.brandList = brandList.data.list
            },

            onValuesChange(picker, values){
                let cityIndex = values[0].index
                let countyIndex = values[1].index

                picker.setSlotValues(1,city[cityIndex])
                picker.setSlotValues(2,county[cityIndex][countyIndex])

                this.areaValues = values

            },

            pickerConfirm(){
                this.pickerShowState = false
                this.settleInForm.area = true
                this.provinceName = this.areaValues[0].label
                this.cityName = this.areaValues[1].label
                this.countyName = this.areaValues[2].label
            },

            barndCheck(e){
                let isOtherBrand = 0
                this.settleInForm.brand.forEach((item,index)=>{
                    if(item == "其他品牌"){
                        isOtherBrand = 1
                    }
                })
                if(isOtherBrand){
                    this.otherBrand_show = true
                    this.formContainerFocus = "formContainerFocus"
                    this.formFocus = "formFocus"
                    // this.rules.otherBrand = [
                    //     { required: true, message: '请输入其他品牌名称', trigger: 'blur' },
                    // ]
                } else{
                    this.otherBrand_show = false
                    this.formContainerFocus = ""
                    this.formFocus = ""
                    // this.rules.otherBrand = ""
                }
            },

            inputFocus(){
                // this.formInputFocus = "formInputFocus"
            },

            openForm(){
                if(this.innerHeight < window.innerHeight){
                    this.formContainerTow = "formContainerTow"
                } else{
                    this.formContainerTow = ""
                }
                this.formShow = true
            },

            inputBlur(){
                // this.formInputFocus = ""
            },

            cancel(){
                this.successToast_show =false
            },

            async onSubmit(){
                let brandIdList = []
                let that = this

                if(this.formFocus && !this.settleInForm.otherBrand){
                    Toast({
                        message: "请填写其他品牌名称",
                        duration: 2000,
                        iconClass: 'icon el-icon-error'
                    });
                    return
                }
                if(!this.areaValues[0].value){
                    Toast({
                        message: "请选择地区",
                        duration: 2000,
                        iconClass: 'icon el-icon-error'
                    });
                    return
                }

                this.brandList.forEach((item)=>{
                    this.settleInForm.brand.forEach(it=>{
                        console.log(item.name== it)
                        if(item.name == it){
                            brandIdList.push(item.id)
                        }
                    })
                })

                let params = {
                        source: this.source,
                        contacts: this.settleInForm.name,
                        mobile: this.settleInForm.phone,
                        province: this.areaValues[0].value,
                        city: this.areaValues[1].value,
                        area: this.areaValues[2].value,
                        brands: brandIdList,
                        brands_other: this.settleInForm.otherBrand
                }

                let res = await submitSettled(params)
                if(res.code == 0){
                    // this.successToast_show = true
                    this.$router.push("/settleInSuccess")
                    // Toast({
                    //     message: '提交成功',
                    //     duration: 2000,
                    //     iconClass: 'icon el-icon-success'
                    // });
                    // setTimeout(()=>{
                    //     that.formShow = false
                    // },2000)
                }
            }
        }

    }
</script>
<style lang="less">
    #page{
        width: 100vw;
        margin: 0;
        padding: 0;
    }
    .pageStyle{
        position: fixed;
    }
    .settleIn{
        .main_img{
        width: 100vw;
        height: auto;
        position: absolute;
        pointer-events: none;
        padding-bottom: 12.2rem;
        }
        .btn_img_container{
            width: 100%;
            display: flex;
            justify-content: center;
        }
        @keyframes btn_img_animation{
            0%{
                transform: scale(90%);
            }
            100%{
                transform: scale(100%);
            }
        }

        .btn_img{
            width: 56.5rem;
            height: 9.1rem;
            position: absolute;
            top: 0;
            z-index: 2;
            top: 79.1rem;
            animation-name: btn_img_animation;
            animation-duration: 700ms;
            animation-iteration-count: infinite;
            animation-direction: alternate-reverse;
            animation-timing-function: linear;
        }

        @keyframes footerAnimation {
            0%{
                transform: translateY(0);
            }
            100%{
                transform: translateY(12.2rem);
            }
        }

        @keyframes footerAnimationRe {
            0%{
                transform: translateY(12.2rem);
            }
            100%{
                transform: translateY(0);
            }
        }

        .footer{
            width: 100vw;
            height: 12.2rem;
            position: fixed;
            bottom: 0;
            background-color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.5ms;
            box-shadow: 0rem 0.3rem 2.6rem -0.9rem rgba(0,0,0,0.36);
        }

        .footer_hideRe{
            animation-name: footerAnimationRe;
            animation-duration: 500ms;
            animation-fill-mode: forwards;
        }

        .footer_hide{
            animation-name: footerAnimation;
            animation-duration: 500ms;
            animation-fill-mode: forwards;
        }

        .join_btn{
            width: 63.1rem;
            height: 8.8rem;
            background: linear-gradient(to right, #0980E8,#2BA4F9);
            color: #fff;
            border-radius: 4.4rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0;
            padding: 0;
            font-size: 3.6rem;
        }

        .form{
            background: rgba(0, 0, 0,0.5);
            width: 100vw;
            height: 200rem;
            position: fixed;
            top: 0;
            left: 0;
            // display: flex;
            // align-items: end;
            z-index: 2;
            .form_container{
                background-color: #fff;
                height: 155rem;
                width: 100vw;
                position: absolute;
                bottom: 0;
                border-radius: 2rem 2rem 0 0;
                padding-bottom: 6.8rem;
            }
            .formContainerFocus{
                height: 175rem;
            }
            .formContainerTow{
                padding-bottom: 0;
            }
            .form_content{
                margin: 2.6rem 5rem 4rem;
                .form_header{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .form_close{
                        position: absolute;
                        right: 3rem;
                    }
                    .form_title{
                        color: #333333;
                        font-size: 3.2rem;
                        letter-spacing: 0.3rem;
                        font-weight: 600;
                    }
                }
                .el-checkbox__inner::after{
                    left: 0.9rem;
                    top: 0.4rem;
                }
                .el-form-item__error{
                    z-index: 2;
                }
                .el-form-item__label{
                    flex-basis: 16rem;
                    letter-spacing: 1.1rem;
                    font-size: 3rem;
                }
                .form_input_block{
                    margin: 2rem 0;

                    .el-form-item{
                        width: 100%;
                        display: flex;
                        margin-bottom: 2rem;
                    }
                    .el-form-item__content{
                        flex-grow: 1;
                    }
                    .el-input__inner{
                        border: 0;
                        border-bottom: 1px solid #E5E5E5;
                        width: 100%;
                    }
                    .el-input.is-disabled .el-input__inner{
                        background: #fff;
                    }
                    .picker_select{
                        display: flex;
                        .el-form-item__label{
                            letter-spacing: normal;
                        }
                        .el-form-item__content{
                            border-bottom: 1px solid #E5E5E5;
                            padding-left: 3rem;
                            color: #C0C4CC;
                        }
                        .right{
                            position: absolute;
                            right: 0;
                            bottom: 0;
                        }
                    }
                    .el-form-item__label{
                        width: 14rem;
                        text-align: left;
                    }
                }
            }
            .checkbox_content{
                .checkbox_title{
                    font-size: 2.8rem;
                    color: #333333;
                    margin-bottom: 3.2rem;
                }
                .el-checkbox__inner {
                    border-radius: 50%;
                    width: 3rem;
                    height: 3rem;
                }
                .el-checkbox{
                    margin: 0;
                    width: 28vw;
                }
                .el-form-item{
                    margin: 0;
                    width: 100%;
                }
                .otherBrand{
                    margin-top: 2rem;
                }
                .el-form-item__content{
                    width: 100%;
                }
            }
            .submit{
                width: 100%;
                height: 8.8rem;
                border-radius: 4.4rem;
                margin-top: 3rem;
                font-size: 3.6rem;
            }
        }
        .formFocus{
            display: flex;
            align-items: end;
            height: 100vh;
            .form_container{
                height: auto;
                position: relative;
            }
        }

        .mask{
            background: rgba(0, 0, 0,0.5);
            width: 100vw;
            height: 100vh;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 3;
            .picker_header{
                display: flex;
                justify-content: space-between;
                font-size: 3rem;
                margin: 4rem 6rem 0;
                padding-bottom: 2rem;
            }
            .picker_contet{
                width: 100vw;
                height: 52rem;
                background-color: #fff;
                position: absolute;
                bottom: 0;
            }
        }

        .mint-toast-icon{
            font-size: 8rem;
        }
        .success_mask{
            display: flex;
            justify-content: center;
            align-items: center;
            .successToast{
                width: 70vw;
                border-radius: 1rem;
                padding: 3.6rem;
                background: #fff;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .success_header{
                display: flex;
                justify-content: end;
                width: 100%;
            }
            .success_icon{

            }
            .success_prompt{
                font-size: 2.8rem;
                text-align: center;
                margin-top: 2.2rem;
                line-height: 1.5;
                margin-bottom: 4.2rem;
            }
            .success_schedule_prompt{
                color: #999999;
                font-size: 2.3rem;
            }
            .success_triangle{
                margin-bottom: 1.9rem;
                font-size: 0;
            }
            .success_vrCode_block{
                width: 80%;
                padding: 1.9rem;
                box-shadow: 0rem 1.5rem 2.8rem 0.1rem rgba(0,0,0,0.05);
                border-radius: 1rem;
                color: #444444;
                font-size: 2.8rem;
                display: flex;
                align-items: center;
                .success_vrCode_text{
                    margin-left: 4.6rem;
                    line-height: 1.5;
                }
                img{
                    width: 11.5rem;
                    height: 11.5rem;
                }
            }
        }

        .confirm{
            width: 80%;
            height: 8.8rem;
            border-radius: 4.4rem;
            margin-top: 3rem;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 3.2rem;
            font-size: 3.6rem;
            background: linear-gradient(to right, #0980E8,#2BA4F9);
        }
    }


</style>



// WEBPACK FOOTER //
// src/page/settleIn3.vue